// 登录
export const loginUrl = () => `/app/account/login`
export const registerUrl = () => `/app/account/register`
export const inviteRegisterUrl = () => `/app/serveice-group/invita-register`
// 修改密码
export const upDataAccountChangePassword = () => '/app/account/change-password'

// 文件上传下载
export const fileUploadToServer = (path: string) => `/Files/create?path=${path}`
export const fileDownFromServer = (id: string) => `/Files/download?id=${id}`
export const viewFile = (id: string) => `/Files/view?id=${id}`
